import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api.service';
import { Observable, of } from 'rxjs';
import { apiRoutes } from '../../../environments/api-routes';
import { LogScannerPasteInterface } from '../models/log-scanner-paste.interface';
import { BarcodeInputService } from '../../utils/barcode-input/barcodeInput.service';

@Injectable({
  providedIn: 'root',
})
export class LogScannerPasteService {
  private apiRoutes = apiRoutes;

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private barcodeInputService: BarcodeInputService,
  ) {}

  checkLog(payload: LogScannerPasteInterface): Observable<void> {
    if (payload.value === this.barcodeInputService.lastPasteValue) {
      return this.http.post<void>(this.apiService.getUrl(this.apiRoutes.monitoring.scannerPaste), payload);
    }
    return of(null);
  }
}
